import React, { Component } from 'react';
import Scroll from 'react-scroll';
import './NavDown.css';

//const scroll = Scroll.animateScroll;
const Link = Scroll.Link;
class NavDown extends Component
{
  render()
  {
    return (

      <Link id="NavDown" className={this.props.backgroundClass} to="BlockAbout" spy={false} smooth={true} duration={500}>
        <i className="fa fa-arrow-circle-down" aria-hidden="true"></i>
      </Link>
    )
  }
}

export default NavDown;



// WEBPACK FOOTER //
// ./src/components/NavDown/NavDown.js